import { action, runInAction, observable } from 'mobx';
import { BaseViewStore, } from 'core/stores';
import { PatientService } from "application/patient/services";
import { PatientNewFlowInsuranceEditModalStore } from 'application/facility-order-new-flow-insurance/stores';

class FacilityOrderPatientNewFlowInsuranceInsuranceEditViewStore extends BaseViewStore {
    @observable accessor btPatient;
    @observable accessor loadingData = false;

    @observable accessor showAddPrimary = false;
    @observable accessor showAddPrimaryInactive = false;
    @observable accessor showAddSecondary = false;
    @observable accessor showAddSecondaryInactive = false;
    @observable accessor showEditPrimary = false;
    @observable accessor showEditPrimaryInactive = false;
    @observable accessor showEditSecondary = false;
    @observable accessor showEditSecondaryInactive = false;
    @observable accessor showDeletePrimary = false;
    @observable accessor showDeletePrimaryInactive = false;
    @observable accessor showDeleteSecondary = false;
    @observable accessor showDeleteSecondaryInactive = false;
    @observable accessor showChangePrimary = false;
    @observable accessor showChangeSecondary = false;
    @observable accessor showEditInsurancePolicy = false;
    @observable accessor disabled = false;
    @observable accessor disableForm = false;

    constructor(rootStore, componentsProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.patient = componentsProps.patient;
        this.refreshInsuranceData = componentsProps.refreshInsuranceData;
        this.openRelationshipChangeModal = componentsProps.openRelationshipChangeModal;
        this.changeFacilityOrderPatientInsuranceStatus = componentsProps.changeFacilityOrderPatientInsuranceStatus;
        this.disableEdit = componentsProps.disableEdit;
        this.facilityOrderPatient = componentsProps.facilityOrderPatient;
        this.facilityOrderTemplates = componentsProps.facilityOrderTemplates;
        this.fetchPatientTemplates = componentsProps.fetchPatientTemplates;
        this.disableForm = componentsProps.disableForm;

        this.patientService = new PatientService(this.rootStore.application.baasic.apiClient);

        this.fetch([
            this.initialize(false)
        ]);
    }

    @action.bound
    async initialize(refreshInsuranceData = false) {
        this.loadingData = true;

        if (refreshInsuranceData) {
            this.closeAll();
            await this.refreshInsuranceData();
        }

        const btPatient = await this.patientService.get(this.patient.patientKey);
        runInAction(() => {
            this.btPatient = btPatient.data;
            this.loadingData = false;
        });
    }

    @action.bound
    closeAll() {
        this.showAddPrimary = false;
        this.showAddPrimaryInactive = false;
        this.showAddSecondary = false;
        this.showAddSecondaryInactive = false;
        this.showEditPrimary = false;
        this.showEditPrimaryInactive = false;
        this.showEditSecondary = false;
        this.showEditSecondaryInactive = false;
        this.showDeletePrimary = false;
        this.showDeletePrimaryInactive = false;
        this.showDeleteSecondary = false;
        this.showDeleteSecondaryInactive = false;
        this.showChangePrimary = false;
        this.showChangeSecondary = false;

        this.showEditInsurancePolicy = false;
    }

    @action.bound
    openAddCard(isPrimary, isActive) {
        this.closeAll();
        this.initializeInsurancStore(isPrimary, isActive, "Add");

        if (isPrimary && isActive) {
            this.showAddPrimary = true;
        } else if (isPrimary && !isActive) {
            this.showAddPrimaryInactive = true;
        }
        else if (!isPrimary && isActive) {
            this.showAddSecondary = true;
        }
        else {
            this.showAddSecondaryInactive = true;
        }
    }

    @action.bound
    openEditCard(isPrimary, isActive) {
        this.closeAll();

        if (isPrimary && isActive) {
            this.showEditPrimary = true;
        } else if (isPrimary && !isActive) {
            this.showEditPrimaryInactive = true;
        }
        else if (!isPrimary && isActive) {
            this.showEditSecondary = true;
        }
        else {
            this.showEditSecondaryInactive = true;
        }
    }

    @action.bound
    openDeleteCard(isPrimary, isActive) {
        this.closeAll();

        if (isPrimary && isActive) {
            this.showDeletePrimary = true;
        } else if (isPrimary && !isActive) {
            this.showDeletePrimaryInactive = true;
        }
        else if (!isPrimary && isActive) {
            this.showDeleteSecondary = true;
        }
        else {
            this.showDeleteSecondaryInactive = true;
        }
    }

    @action.bound
    openChangeCard(isPrimary, isActive) {
        this.closeAll();
        this.initializeInsurancStore(isPrimary, isActive, "Change");

        if (isPrimary && isActive) {
            this.showChangePrimary = true;
        } else if (isPrimary && !isActive) {
            this.showChangePrimaryInactive = true;
        }
        else if (!isPrimary && isActive) {
            this.showChangeSecondary = true;
        }
        else {
            this.showChangeSecondaryInactive = true;
        }
    }

    @action.bound
    confirmEditInsurancePolicy(isPrimary, isActive) {
        this.initializeInsurancStore(isPrimary, isActive, "Edit");
        this.showEditInsurancePolicy = true;
    }

    @action.bound
    initializeInsurancStore(isPrimary, isActive, action) {
        let title = isPrimary ?
            (isActive ? `${action} Primary Insurance Information` : `${action} Inactive Medicare Policy`) :
            (isActive ? `${action}  Secondary Insurance Information` : `${action} Inactive Medicaid Policy`);

        let insurance = isPrimary ?
            (isActive ? this.btPatient.primaryActivePayor : this.btPatient.primaryInactivePayor) :
            (isActive ? this.btPatient.secondaryActivePayor : this.btPatient.secondaryInactivePayor);

        this.patientNewFlowInsuranceEditModalStore = new PatientNewFlowInsuranceEditModalStore(this.rootStore,
            {
                title: title,
                insurance: insurance,
                patient: this.patient,
                btPatient: this.btPatient,
                isPrimary: isPrimary,
                isActive: isActive,
                action: action.toLowerCase(),
                closeAll: () => this.closeAll(),
                refreshInsuranceData: async () => await this.initialize(true),
                openRelationshipChangeModal: async () => await this.openRelationshipChangeModal(),
                changeFacilityOrderPatientInsuranceStatus: this.changeFacilityOrderPatientInsuranceStatus ? () => this.changeFacilityOrderPatientInsuranceStatus() : null,
                facilityOrderPatient: this.facilityOrderPatient,
                facilityOrderTemplates: this.facilityOrderTemplates,
                fetchPatientTemplates: this.fetchPatientTemplates
            }
        );
    }

    @action.bound
    async deleteInsurancePolicy(isPrimary, isActive, name) {
        this.disabled = true;
        try {
            if (isPrimary) {
                await this.patientService.updatePatientInsuranceNewFlow({
                    patientBrightreeId: this.patient.patientKey,
                    primaryInsuranceName: name,
                    isRemove: true,
                    isInactive: !isActive,
                    facilityOrderId: this.facilityOrderPatient.facilityOrderId,
                    patientId:  this.facilityOrderPatient.patientId,
                });
            } else {
                await this.patientService.updatePatientInsuranceNewFlow({
                    patientBrightreeId: this.patient.patientKey,
                    secondaryInsuranceName: name,
                    isRemove: true,
                    isInactive: !isActive
                });
            }
            await this.initialize(true);
        } catch (err) {
            this.rootStore.notificationStore.error(err && err.data ? err.data : "Error occured while trying to remove insurance.");
        }
        this.disabled = false;
    }
}

export default FacilityOrderPatientNewFlowInsuranceInsuranceEditViewStore;